export default function deepEqual(a, b) {
    if (typeof a !== typeof b || Array.isArray(a) !== Array.isArray(b)) {
        return false;
    } else if (a === b) {
        return true;
    } else if (Array.isArray(a)) {
        return a.length === b.length && a.every((val, i) => deepEqual(val, b[i]));
        // typeof null === "object"...
    } else if (typeof a === "object" && a !== null && b !== null) {
        let a_keys = Object.keys(a).sort(),
            a_values = a_keys.map(key => a[key]),
            b_keys = Object.keys(b).sort(),
            b_values = b_keys.map(key => b[key]);

        return deepEqual(a_keys, b_keys) && deepEqual(a_values, b_values);
    }else{
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/lib/deepEqual.js